import { STATUS } from "./Status.types"

export type Substatus = 'ACTIVE' | 'PASSIVE' | 'INACTIVE';

export class SUBSTATUS {
    public static ACTIVE: any = {
        // CANDIDATE
        SEARCH_OPTIONS: 1,
        FEEDBACK_OPTIONS: 2,
        PROPOSE: 3,
        FEEDBACK_OFFER: 4,
        FIRST_INTERVIEW: 5,
        SECOND_INTERVIEW: 6,
        THIRD_INTERVIEW: 7,
        EMPLOYMENT_CONDITION_INTERVIEW: 8,
        POSTED: 9,
        NEW_CANDIDATE: 17,
        APPLICATION_PROCEDURE: 18,
        RATING: 19,

        // VACANCIES
        CONCEPT: 10,
        UP_TO_DATE: 11,

        // BUSINESS UNIT
        SUSPECT: 12,
        PROSPECT: 13,
        AGREED_CONDITIONS: 14,
        CLIENT: 15,
// OFFER
        PROPOSED: 20,
        CONVERSATION: 21,
        ZZP: 22,
        TEMP_ACTIVE: 16,
        DECLINED: 206,

        RECORD_CONCEPT: 1000
    }

    public static INACTIVE: any = {
        // CANDIDATE
        OTHER_WORK_AREA: 100,
        NOT_INTERESTED_IN_SECONDMENT: 101,
        NOT_SUITED: 102,

        // VACANCY
        EXPIRED: 103,

        // BUSINESS UNIT
        DENIED_CONDITIONS: 104,
        NO_SUITABLE_VACANCIES: 105,
        NO_COLLABORATE_AGENCIES: 106,

        TEMP_INACTIVE: 107
    }

    public static PASSIVE: any = {
        // CANDIDATE
        SPECIFIC_CONDITIONS: 200,
        FOLLOW_UP_LATER: 201,

        // VACANCY
        NOT_UP_TO_DATE: 202,

        // BUSINESS UNIT
        FORMER_CLIENT: 203,

        TEMP_PASSIVE: 204
    }

    public static GUIDELINES = [
        SUBSTATUS.ACTIVE.CREATED,
        SUBSTATUS.ACTIVE.SIGNED,
        SUBSTATUS.ACTIVE.PROPOSED,
        SUBSTATUS.ACTIVE.DEPLOYED
    ]

    public static CANDIDATE = {
        ACTIVE: [
            SUBSTATUS.ACTIVE.APPLICATION_PROCEDURE,
            SUBSTATUS.ACTIVE.RATING,
            SUBSTATUS.ACTIVE.SEARCH_OPTIONS,
            SUBSTATUS.ACTIVE.FEEDBACK_OPTIONS,
            SUBSTATUS.ACTIVE.PROPOSE,
            SUBSTATUS.ACTIVE.FEEDBACK_OFFER,
            SUBSTATUS.ACTIVE.FIRST_INTERVIEW,
            SUBSTATUS.ACTIVE.SECOND_INTERVIEW,
            SUBSTATUS.ACTIVE.THIRD_INTERVIEW,
            SUBSTATUS.ACTIVE.EMPLOYMENT_CONDITION_INTERVIEW,
            SUBSTATUS.ACTIVE.POSTED
        ],
        INACTIVE: [
            SUBSTATUS.INACTIVE.OTHER_WORK_AREA,
            SUBSTATUS.INACTIVE.NOT_INTERESTED_IN_SECONDMENT,
            SUBSTATUS.INACTIVE.NOT_SUITED,
        ],
        PASSIVE: [
            SUBSTATUS.PASSIVE.SPECIFIC_CONDITIONS,
            SUBSTATUS.PASSIVE.FOLLOW_UP_LATER,
        ]
    }

    public static VACANCY = {
        ACTIVE: [
            SUBSTATUS.ACTIVE.CONCEPT,
            SUBSTATUS.ACTIVE.UP_TO_DATE,
        ],
        INACTIVE: [
            SUBSTATUS.INACTIVE.EXPIRED,
        ],
        PASSIVE: [
            SUBSTATUS.PASSIVE.NOT_UP_TO_DATE,
        ]
    }

    public static BUSINESS = {
        ACTIVE: [
            SUBSTATUS.ACTIVE.TEMP_ACTIVE,
        ],
        INACTIVE: [
            SUBSTATUS.INACTIVE.TEMP_INACTIVE,
        ],
        PASSIVE: [
            SUBSTATUS.PASSIVE.TEMP_PASSIVE
        ]
    }

    public static BUSINESS_UNIT = {
        ACTIVE: [
            SUBSTATUS.ACTIVE.SUSPECT,
            SUBSTATUS.ACTIVE.PROSPECT,
            SUBSTATUS.ACTIVE.AGREED_CONDITIONS,
            SUBSTATUS.ACTIVE.CLIENT,
        ],
        INACTIVE: [
            SUBSTATUS.INACTIVE.DENIED_CONDITIONS,
            SUBSTATUS.INACTIVE.NO_SUITABLE_VACANCIES,
            SUBSTATUS.INACTIVE.NO_COLLABORATE_AGENCIES,
        ],
        PASSIVE: [
            SUBSTATUS.PASSIVE.FORMER_CLIENT
        ]
    }

    public static CONTACT = {
        ACTIVE: [
            SUBSTATUS.ACTIVE.TEMP_ACTIVE,
        ],
        INACTIVE: [
            SUBSTATUS.INACTIVE.TEMP_INACTIVE,
        ],
        PASSIVE: [
            SUBSTATUS.PASSIVE.TEMP_PASSIVE
        ]
    }

    public static getLabelByValue = (item: any) => {
        switch (item) {
            case SUBSTATUS.ACTIVE.NEW_CANDIDATE:
            case 'NEW_CANDIDATE':
                return 'Nieuwe kandidaat';
            case SUBSTATUS.ACTIVE.RATING:
            case 'RATING':
                return 'Beoordeling';
            case SUBSTATUS.ACTIVE.SEARCH_OPTIONS:
            case 'SEARCH_OPTIONS':
                return 'Opties zoeken';
            case SUBSTATUS.ACTIVE.FEEDBACK_OPTIONS:
            case 'FEEDBACK_OPTIONS':
                return 'Feedback opties';
            case SUBSTATUS.ACTIVE.PROPOSED:
            case 'PROPOSED':
                return 'Aangeboden';
            case SUBSTATUS.ACTIVE.CONVERSATION:
            case 'CONVERSATION':
                return 'Op gesprek';
            case SUBSTATUS.ACTIVE.PROPOSE:
            case 'PROPOSE':
                return 'Aanbieden';
            case SUBSTATUS.ACTIVE.FEEDBACK_OFFER:
            case 'FEEDBACK_OFFER':
                return 'Feedback aanbieding';
            case SUBSTATUS.ACTIVE.FIRST_INTERVIEW:
            case 'FIRST_INTERVIEW':
                return 'Intro gesprek inplannen';
            case SUBSTATUS.ACTIVE.SECOND_INTERVIEW:
            case 'SECOND_INTERVIEW':
                return 'Tweede gesprek inplannen';
            case SUBSTATUS.ACTIVE.THIRD_INTERVIEW:
            case 'THIRD_INTERVIEW':
                return 'Derde gesprek inplannen';
            case SUBSTATUS.ACTIVE.EMPLOYMENT_CONDITION_INTERVIEW:
            case 'EMPLOYMENT_CONDITION_INTERVIEW':
                return 'Arbeidsvoorwaardelijk gesprek inplannen';
            case SUBSTATUS.ACTIVE.POSTED:
            case 'POSTED':
                return 'Plaatsing';
            case SUBSTATUS.ACTIVE.APPLICATION_PROCEDURE:
            case 'APPLICATION_PROCEDURE':
                return 'Sollicitatieprocedure';
            case SUBSTATUS.ACTIVE.ZZP:
            case 'ZZP':
                return 'ZZP\'er';

            case SUBSTATUS.ACTIVE.CONCEPT:
            case 'CONCEPT':
                return 'Concept';
            case SUBSTATUS.ACTIVE.UP_TO_DATE:
            case 'UP_TO_DATE':
                return 'Actueel';

            case SUBSTATUS.ACTIVE.SUSPECT:
            case 'SUSPECT':
                return 'Suspect';
            case SUBSTATUS.ACTIVE.PROSPECT:
            case 'PROSPECT':
                return 'Prospect';
            case SUBSTATUS.ACTIVE.AGREED_CONDITIONS:
            case 'AGREED_CONDITIONS':
                return 'Voorwaarden akkoord';
            case SUBSTATUS.ACTIVE.CLIENT:
            case 'CLIENT':
                return 'Opdrachtgever';

            case SUBSTATUS.INACTIVE.OTHER_WORK_AREA:
            case 'OTHER_WORK_AREA':
                return 'Ander werkgebied';
            case SUBSTATUS.INACTIVE.NOT_INTERESTED_IN_SECONDMENT:
            case 'NOT_INTERESTED_IN_SECONDMENT':
                return 'Geen interesse in detachering';
            case SUBSTATUS.INACTIVE.NOT_SUITED:
            case 'NOT_SUITED':
                return 'Sluit niet aan';

            case SUBSTATUS.INACTIVE.EXPIRED:
            case 'EXPIRED':
                return 'Functie vervallen';

            case SUBSTATUS.INACTIVE.DENIED_CONDITIONS:
            case 'DENIED_CONDITIONS':
                return 'Voorwaarden niet akkoord';
            case SUBSTATUS.INACTIVE.NO_SUITABLE_VACANCIES:
            case 'NO_SUITABLE_VACANCIES':
                return 'Geen passende vacatures';
            case SUBSTATUS.INACTIVE.NO_COLLABORATE_AGENCIES:
            case 'NO_COLLABORATE_AGENCIES':
                return 'Werken niet met bureaus';

            case SUBSTATUS.PASSIVE.SPECIFIC_CONDITIONS:
            case 'SPECIFIC_CONDITIONS':
                return 'Specifieke voorwaarden';
            case SUBSTATUS.PASSIVE.FOLLOW_UP_LATER:
            case 'FOLLOW_UP_LATER':
                return 'Later opvolgen';
            case SUBSTATUS.INACTIVE.DECLINED:
            case 'DECLINED':
                return 'Afgewezen';
            case SUBSTATUS.PASSIVE.NOT_UP_TO_DATE:
            case 'NOT_UP_TO_DATE':
                return 'Niet actueel';

            case SUBSTATUS.PASSIVE.FORMER_CLIENT:
            case 'FORMER_CLIENT':
                return 'Ex-opdrachtgever';

            case 'CANCELLED':
                return 'Opgeheven';

            case SUBSTATUS.ACTIVE.TEMP_ACTIVE:
            case 'TEMP_ACTIVE':
                return 'Actief';
            case SUBSTATUS.INACTIVE.TEMP_INACTIVE:
            case 'TEMP_INACTIVE':
                return 'Inactief';
            case SUBSTATUS.PASSIVE.TEMP_PASSIVE:
            case 'TEMP_PASSIVE':
                return 'Passief';



            default:
                return 'Status Unknown';
        }
    }

    public static getEntityStatus(entity) {
        switch (entity) {
            case 'vacancy':
                return SUBSTATUS.VACANCY;
            case 'candidate':
                return SUBSTATUS.CANDIDATE;
            case 'business':
                return SUBSTATUS.BUSINESS;
            case 'business_unit':
                return SUBSTATUS.BUSINESS_UNIT;
            case 'contact':
                return SUBSTATUS.CONTACT;
        }
    };

    public static getSubstatusByStatus = (status: any) => {
        switch (status) {
            case STATUS.INACTIVE:
                return SUBSTATUS.INACTIVE;
            case STATUS.ACTIVE:
                return SUBSTATUS.ACTIVE;
            case STATUS.PASSIVE:
                return SUBSTATUS.PASSIVE;
            default:
                return {};
        }
    }

    public static getDropdownList = (substatus: any) => {
        return Object.values(substatus).map((item: any) => {
            return {
                status: STATUS.getStatusBySubStatus(item),
                label: SUBSTATUS.getLabelByValue(item),
                value: item
            }
        })
    }

    public static getDefaultByEntity(entity: string) {
        switch (entity) {
            case 'vacancy':
                return 'CONCEPT';
            case 'candidate':
                return 'NEW_CANDIDATE';
            case 'business_unit':
                return 'SUSPECT';
            case 'contact':
            default:
                return 'TEMP_ACTIVE';
        }
    }

    private static getOfferListByStatus(status: Substatus) {
        switch (status) {
            case 'ACTIVE':
                return [
                    'CONCEPT',
                    'UP_TO_DATE'
                ];
            case 'PASSIVE':
                return [
                    'NOT_UP_TO_DATE'
                ];
            case 'INACTIVE':
                return [
                    'EXPIRED'
                ];
            default:
                return [];
        }
    }


    private static getVacancyListByStatus(status: Substatus) {
        switch (status) {
            case 'ACTIVE':
                return [
                    'CONCEPT',
                    'UP_TO_DATE'
                ];
            case 'PASSIVE':
                return [
                    'NOT_UP_TO_DATE'
                ];
            case 'INACTIVE':
                return [
                    'EXPIRED'
                ];
            default:
                return [];
        }
    }

    private static getCandidateListByStatus(status: Substatus) {
        switch (status) {
            case 'ACTIVE':
                return [
                    'NEW_CANDIDATE',
                    'APPLICATION_PROCEDURE',
                    'RATING',
                    'SEARCH_OPTIONS',
                    'FEEDBACK_OPTIONS',
                    'PROPOSE',
                    'FEEDBACK_OFFER',
                    'FIRST_INTERVIEW',
                    'SECOND_INTERVIEW',
                    'THIRD_INTERVIEW',
                    'EMPLOYMENT_CONDITION_INTERVIEW',
                    'POSTED',
                    'ZZP'
                ];
            case 'PASSIVE':
                return [
                    'SPECIFIC_CONDITIONS',
                    'FOLLOW_UP_LATER',
                ];
            case 'INACTIVE':
                return [
                    'OTHER_WORK_AREA',
                    'NOT_INTERESTED_IN_SECONDMENT',
                    'NOT_SUITED',
                ];
            default:
                return [];
        }
    }

    private static getBusinessUnitListByStatus(status: Substatus) {
        switch (status) {
            case 'ACTIVE':
                return [
                    'SUSPECT',
                    'PROSPECT',
                    'AGREED_CONDITIONS',
                    'CLIENT',
                ];
            case 'PASSIVE':
                return [
                    'FORMER_CLIENT'
                ];
            case 'INACTIVE':
                return [
                    'DENIED_CONDITIONS',
                    'NO_SUITABLE_VACANCIES',
                    'NO_COLLABORATE_AGENCIES',
                    'CANCELLED'
                ];
            default:
                return [];
        }
    }

    private static getContactListByStatus(status: Substatus) {
        switch (status) {
            case 'ACTIVE':
                return [
                    'TEMP_ACTIVE',
                ];
            case 'PASSIVE':
                return [
                    'TEMP_PASSIVE'
                ];
            case 'INACTIVE':
                return [
                    'TEMP_INACTIVE',
                ];
            default:
                return [];
        }
    }

    public static getListByEntityNameByStatus(entity: 'vacancy' | 'candidate' | 'contact' | 'business_unit' | 'offer', status: Substatus) {
        switch (entity) {
            case 'vacancy':
                return this.getVacancyListByStatus(status);
            case 'candidate':
                return this.getCandidateListByStatus(status);
            case 'business_unit':
                return this.getBusinessUnitListByStatus(status);
            case 'contact':
                return this.getContactListByStatus(status);
            case 'offer':
                return this.getOfferListByStatus(status);
            default:
                return [];
        }
    }
}